import React from 'react';
import { Shield, Lock, Zap } from 'lucide-react';
import { motion } from 'framer-motion';

const TrustStrip = () => {
  const items = [
    { icon: Shield, text: 'No data stored' },
    { icon: Lock, text: 'Automatic redaction' },
    { icon: Zap, text: 'Processed instantly' },
  ];

  return (
    <div className="bg-trust/5 border-y border-trust/10 py-6" data-testid="trust-strip">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="flex items-center justify-center md:justify-start gap-3"
            >
              <div className="bg-trust/10 p-2 rounded-md">
                <item.icon className="w-5 h-5 text-trust" />
              </div>
              <span className="font-public font-medium text-slate-700">{item.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustStrip;
